import { render } from "./AnswerWindow.vue?vue&type=template&id=7ef1a0b3"
import script from "./AnswerWindow.vue?vue&type=script&lang=js"
export * from "./AnswerWindow.vue?vue&type=script&lang=js"

import "./AnswerWindow.vue?vue&type=style&index=0&id=7ef1a0b3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__